import React from 'react';
import { mainDarkColor } from '../../../lib/theme';

export const pendingScoreStyle: React.CSSProperties = {
  // mainDarkColor is picked to keep the outline at 3:1 through this opacity; change them together.
  opacity: 0.6,
  outline: `2px dashed ${mainDarkColor}`,
  outlineOffset: 2,
};
